<template>
  <div class="form-check optionWrapper">
    <label class="form-check-label checkbox">
      <sb-checkbox :checked="value.isChecked" v-on:update:checked="$emit('updateCheck', $event, value, scoreType)"/>
      by selecting the checkbox you are opting to receive a triggered email when a customer fills in a {{score_type}} score equal to or below the filled in value
    </label>

    <div v-if="value.isChecked" class="descriptionWrapper">
      <div class="desc">
        <span>minimum {{score_type}} value</span><br>
        <span>(must be a numeric value in the range of 1-5)</span>
      </div>
      <div class="text-box">
        <input type="number" min="1" max="5" class="form-control text-val" :class="{danger: value.hasError}" v-model="value.score" @blur="$emit('handleChange', value, scoreType)">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scoreType: [String],
    value: [Object]
  },

  computed: {
    score_type(){
      return this.scoreType === 'crs' ? 'cs': this.scoreType
    }
  },
  
    
}
</script>

